module.exports = __webpack_public_path__ + "img/green-foot.3c0f2a57.png";